/**
 * The states for Diangosis model instance.
 *
 * @author jonmd
 */
class State {
  static NOT_SET: State;
  static PUBLISHED: State;
  static DRAFT: State;
  static STUB: State;
  static DELETED: State;

  private static _values: State[] = [];
  private static _lookup: Map<string, State> = new Map();

  static fromTag(tag: string) {
    const state = State._lookup.get(tag);
    if (state === undefined) {
      throw new Error('Not a valid State.tag: ' + tag);
    }
    return state;
  }

  static values(): State[] {
    return [...State._values];
  }

  // ---

  readonly tag: string;
  readonly label: string;

  constructor(tag: string, label: string) {
    this.tag = tag;
    this.label = label;
    State._values.push(this);
    State._lookup.set(tag, this);
  }

  toString() {
    return '<State: tag=' + this.tag + ', label=' + this.label + '>';
  }
}

State.NOT_SET = new State('', 'n/a');
State.PUBLISHED = new State('p', 'Published');
State.DRAFT = new State('d', 'Draft');
State.STUB = new State('s', 'Stub');
State.DELETED = new State('x', 'Deleted');

export { State };
